import React, { useState, useEffect, useRef } from 'react';
import { Beneficio } from './Beneficio';
import PropTypes from 'prop-types';
import '../../css/components/BannerInicio/BeneficiosCarrusel.css';

export const BeneficiosCarrusel = ({ beneficios }) => {
  const seccionBeneficios = [];
  const seccionCirculos = [];
  const [indiceBeneficio, setIndiceBeneficio] = useState(0);
  const intervalRef = useRef(null);

  const intervalCallback = () => {
    if (indiceBeneficio === beneficios.length - 1) {
      setIndiceBeneficio(0);
    } else {
      setIndiceBeneficio(indiceBeneficio + 1);
    }
  };

  const onControlClick = (index) => {
    clearInterval(intervalRef.current);

    setIndiceBeneficio(index);

    intervalRef.current = setInterval(intervalCallback, 4000);
  };

  useEffect(() => {
    intervalRef.current = setInterval(intervalCallback, 4000);

    return () => {
      clearInterval(intervalRef.current);
    };
  });

  for (let i = 0; i < beneficios.length; i++) {
    seccionBeneficios.push((
      <div key={i} className={`beneficios-carrusel__beneficio ${indiceBeneficio === i ? 'beneficios-carrusel__beneficio-visible' : ''}`}>
        <Beneficio {... beneficios[i]}/>
      </div>
    ));

    seccionCirculos.push((
      <div className='beneficios-carrusel__control' key={i} onClick={() => {onControlClick(i)}}>
        <div className={`beneficios-carrusel__circulo ${indiceBeneficio === i ? 'beneficios-carrusel__circulo-seleccionado' : ''}`}></div>
      </div>
    ));
  }

  return (
    <div>
      <div className='beneficios-carrusel__contenedor'>
        {seccionBeneficios}
      </div>

      <div className='beneficios-carrusel__controles'>
        {seccionCirculos}
      </div>
    </div>
  );
}

BeneficiosCarrusel.propTypes = {
  beneficios: PropTypes.arrayOf(PropTypes.shape({
    texto: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    urlIcono: PropTypes.string.isRequired
  })).isRequired
};


// WEBPACK FOOTER //
// ./src/components/BannerInicio/BeneficiosCarrusel.js